import { RegisterRequest, RegisterResponse } from '../register';
import * as _m0 from "protobufjs/minimal";
import { getServiceUrl } from '../utils/api';

export async function register(request: RegisterRequest): Promise<RegisterResponse> {
    const encodedRequest = RegisterRequest.encode(request).finish();
    const base64 = _m0.util.base64.encode(encodedRequest, 0, encodedRequest.length);

    const url = getServiceUrl('authservice', 'register');

    const response = await fetch(
        url, {
        method: 'POST',
        headers: {
        },
        credentials: 'include', // Necessary to accept and store the HttpOnly cookie
        body: base64
    }
    );

    if (response.status !== 200) {
        const errorText = await response.text();
        try {
            const errorJson = JSON.parse(errorText);
            throw new Error(`Unable to register! Status: ${response.status}, Message: ${errorJson.error || errorText}`);
        } catch (e) {
            throw new Error(`Unable to register! Status: ${response.status}, Message: ${errorText}`);
        }
    }

    const encodedByteString = await response.text();

    const decodedByteString = atob(encodedByteString);
    const decodedBytes = new Uint8Array(decodedByteString.length);
    for (let i = 0; i < decodedByteString.length; i++) {
        decodedBytes[i] = decodedByteString.charCodeAt(i);
    }

    return RegisterResponse.decode(decodedBytes);
}
